export const FETCH_CONNECTION_SUCCESS = "FETCH_CONNECTION_SUCCESS";